import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Status, siteMenu } from '../../site-menu';

@Component({
  selector: 'obs-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ObservatoryHomeComponent {
  siteMenu = siteMenu;
  status = Status;

  displayedColumns: string[] = ['name', 'selector', 'codeDone', 'designDone', 'guideDone'];
}
